const SubscriptionDataTitle = ({ children }: { children: React.ReactNode }) => {
  return <h5 className="text-sm font-bold uppercase pb-2">{children}</h5>;
};

export default SubscriptionDataTitle;
